import { useCallback, useEffect, useState } from "react";
import { api } from "../api/http";
import type { LegalVersionsResponse } from "../api/types";

export function useLegalVersions(enabled: boolean) {
  const [data, setData] = useState<LegalVersionsResponse | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const res = await api.get<LegalVersionsResponse>("/api/v1/auth/legal/versions/");
      setData(res);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) void refresh();
  }, [enabled, refresh]);

  const accept = useCallback(async () => {
    await api.post("/api/v1/auth/legal/accept/");
    await refresh();
  }, [refresh]);

  return { data, loading, refresh, accept };
}
